import {Stack, Tooltip} from '@mui/material';
import {type FishGroup, WriteQualityModelAttributeAssignmentTypeEnum} from 'client';
import {useTranslation} from 'react-i18next';
import {AutomaticIcon, CustomIcon, DefaultIcon} from 'styles/icons';

export const ModelIcon = (
  assignmentType: WriteQualityModelAttributeAssignmentTypeEnum,
  fontSize: 'inherit' | 'small',
) => {
  switch (assignmentType) {
    case WriteQualityModelAttributeAssignmentTypeEnum.Default:
      return <DefaultIcon fontSize={fontSize} />;
    case WriteQualityModelAttributeAssignmentTypeEnum.Custom:
      return <CustomIcon fontSize={fontSize} />;
    case WriteQualityModelAttributeAssignmentTypeEnum.Automatic:
      return <AutomaticIcon fontSize={fontSize} />;
    default:
      return null;
  }
};

export const ModelIconWithTooltip = ({
  assignmentType,
  fontSize,
}: {
  assignmentType: WriteQualityModelAttributeAssignmentTypeEnum;
  fontSize: 'inherit' | 'small';
}) => {
  const {t} = useTranslation('common');
  return (
    <Tooltip title={`${t(assignmentType)} ${t('qualityModel').toLowerCase()}`} arrow>
      <Stack>{ModelIcon(assignmentType, fontSize)}</Stack>
    </Tooltip>
  );
};

export const mixedQuality = (fishGroups: FishGroup[]): boolean => {
  if (fishGroups.length > 1) {
    const firstValue = fishGroups[0].qualityModelAttribute?.assignmentType;
    return fishGroups.some((fishGroup) => fishGroup.qualityModelAttribute?.assignmentType !== firstValue);
  }
  return false;
};
